import { render, staticRenderFns } from "./ExpiredAdmin.vue?vue&type=template&id=46af081a"
import script from "./ExpiredAdmin.vue?vue&type=script&lang=js"
export * from "./ExpiredAdmin.vue?vue&type=script&lang=js"
import style0 from "./ExpiredAdmin.vue?vue&type=style&index=0&id=46af081a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports